<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Einstellungen</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Mit Trashed</option>
          <option value="only">Nur Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-green" :href="route('settings.create')">
        <span>Erschaffen</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Schlüssel</th>
          <th class="px-6 pt-6 pb-4">Value</th>
          <th class="px-6 pt-6 pb-4">Text</th>
        </tr>
        <tr v-for="setting in settings.data" :key="setting.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-kreditgenie-text-green" :href="route('settings.edit', setting.id)">
              {{ setting.key }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('settings.edit', setting.id)" tabindex="-1">
              {{ setting.value }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('settings.edit', setting.id)" tabindex="-1">
              {{ setting.text | stripHTML }}
            </inertia-link>
          </td>
        </tr>
        <tr v-if="settings.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Keine Einstellungen gefunden.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="settings.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'

export default {
  metaInfo: { title: 'Einstellungen' },
  components: {
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    settings: Object,
  },

  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('settings'), pickBy(this.form), { preserveState: true })
      }, 100),
    },
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },

  filters: {
    stripHTML: function(string) {
      return string ? string.replace(/<\/?[^>]+>|&nbsp;/ig, ' ') : string
    },
  },

}
</script>
